import { BrowserRouter, Switch, Route } from "react-router-dom";
import QuizList from "components/QuizList/QuizList";
import QuizManager from "components/Quiz/QuizManager";
import Container from "components/Home/Container";
import Analayze from "components/QuizAnalayze/Analayze";

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" component={Container} exact />
        <Route path="/quiz" component={QuizList} exact />
        <Route path="/quiz/:id" component={QuizManager} exact />
        <Route path="/result" component={Analayze} />
        <Route component={Container} />
      </Switch>
    </BrowserRouter>
  );
};

export default AppRouter;
